import React, { Component } from 'react'
import {Row,Col, Form, Button,Modal} from 'react-bootstrap';
import classes from './SelectDateAndTime.module.css'


class SelectDateAndTime extends Component{

    render(){
        return(
            <div>
                Select Date and time
            </div>
        )
    }
}

export default SelectDateAndTime;